/* Define all localStorage items here */

export const TOKEN = 'token';